function getPercentage(current, total) {
    return (current * 100) / total;
}
export { getPercentage };
//# sourceMappingURL=get-percentage.js.map